import { handleError } from "../../utils/Common/Constant";
import apiClient from "../Connection/Connection";
// get license list
export const getLicenseList = async (currentPage: number, pageSize: number) => {
  try {
    return (
      await apiClient.get(
        `/license/licenseList?currentPage=${currentPage}&pageSize=${pageSize}`,
      )
    )?.data;
  } catch (error) {
    handleError(error);
  }
};

// update license settings status
export const updateLicenseStatus = async (data: any) => {
  try {
    return (await apiClient.post("/license/settings", data))?.data;
  } catch (error) {
    handleError(error);
  }
};

// get license status
export const getLicenseWithStatus = async (search: string) => {
  try {
    return (
      await apiClient.get(`/license/companylicenseSettings?search=${search}`)
    )?.data;
  } catch (error) {
    handleError(error);
  }
};
